

document.addEventListener("DOMContentLoaded", function() {
    $('.cart-page-fe-slider ul').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      // autoplay: true,
      // autoplaySpeed: 3000,
      infinite: true,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });



  document.querySelector('a[href="#store_infoPopup"]').addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('#store_infoPopup').classList.add('open');
  });
  document.querySelector('#store_infoPopup .closePopup').addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('#store_infoPopup').classList.remove('open');
  });








